export const DEFAULT_THIRD_PARTY_TAB = "overview";

export const THIRD_PARTY_TAB_IDS = [
  "overview",
  "vendors",
  "assessments",
  "questionnaire",
  "evidence",
  "findings",
  "incidents",
  "contacts",
];

/** Disabled until screens are enabled — see TODO comments in ThirdParty.js */
export const THIRD_PARTY_DISABLED_TAB_IDS = ["risks", "reports"];

export const DEFAULT_VENDOR_DETAIL_TAB = "general";

export const VENDOR_DETAIL_TAB_IDS = [
  "general",
  "questionnaire",
  "dependency",
  "evidence",
  "findings",
  "incidents",
  "report",
];

export function isValidThirdPartyTab(tab) {
  if (!tab) return false;
  return THIRD_PARTY_TAB_IDS.includes(tab);
}

export function isValidVendorDetailTab(tab) {
  if (!tab) return false;
  return VENDOR_DETAIL_TAB_IDS.includes(tab);
}

/**
 * Build a shareable Third Party module URL.
 * @param {string} tab
 * @param {{ vendorId?: number|string, vendorDetailTab?: string }} opts
 */
export function thirdPartyPath(tab = DEFAULT_THIRD_PARTY_TAB, { vendorId, vendorDetailTab } = {}) {
  const safeTab = isValidThirdPartyTab(tab) ? tab : DEFAULT_THIRD_PARTY_TAB;

  if (vendorId != null && vendorId !== "" && safeTab === "vendors") {
    const base = `/third_party/vendors/${vendorId}`;
    const detailTab = vendorDetailTab || DEFAULT_VENDOR_DETAIL_TAB;
    if (detailTab !== DEFAULT_VENDOR_DETAIL_TAB && isValidVendorDetailTab(detailTab)) {
      return `${base}/${detailTab}`;
    }
    return base;
  }

  return `/third_party/${safeTab}`;
}

/** Parse pathname into Third Party navigation state. */
export function parseThirdPartyLocation({ pathname }) {
  const parts = pathname.split("/").filter(Boolean);

  if (parts[0] !== "third_party") {
    return {
      tab: DEFAULT_THIRD_PARTY_TAB,
      vendorId: null,
      vendorDetailTab: DEFAULT_VENDOR_DETAIL_TAB,
    };
  }

  if (parts[1] === "vendors" && parts[2]) {
    const detailTab = parts[3] || DEFAULT_VENDOR_DETAIL_TAB;
    return {
      tab: "vendors",
      vendorId: parts[2],
      vendorDetailTab: isValidVendorDetailTab(detailTab) ? detailTab : DEFAULT_VENDOR_DETAIL_TAB,
    };
  }

  const tab = parts[1] || DEFAULT_THIRD_PARTY_TAB;
  const resolvedTab =
    THIRD_PARTY_DISABLED_TAB_IDS.includes(tab) || !isValidThirdPartyTab(tab)
      ? DEFAULT_THIRD_PARTY_TAB
      : tab;
  return {
    tab: resolvedTab,
    vendorId: null,
    vendorDetailTab: DEFAULT_VENDOR_DETAIL_TAB,
  };
}
